export function closeiOSKeyboard() {
    document.activeElement && document.activeElement.blur();
}
